import { useNavigate, Link } from 'react-router-dom';
import { supabase } from '../../lib/supabaseClient';
import { useStaffGate } from '../../lib/staffContext';
import { StaffShell } from '../../ui/StaffShell';
import { ContextError } from '../../ui/ContextError';
import { Lockup } from '../../ui/Lockup';
import { LangToggle, useI18n } from '../../i18n';
import { useDocumentTitle } from '../../ui/a11y';
import { roleLabel } from '../../ui/roles';
import { ComplianceList } from './ComplianceList';

// J2 for the school admin (whose own screens come later): the pack only.
export function SchoolAdminCompliance() {
  const { t } = useI18n();
  const navigate = useNavigate();
  const { ctx, error } = useStaffGate(['school_admin']);
  if (error) return <ContextError message={error} />;
  if (!ctx || !ctx.active_role) return <main className="page-loading" role="status">{t.loading}</main>;
  return (
    <StaffShell
      role={roleLabel(t, ctx.active_role)}
      nav={[
        { icon: '🏠', label: t['home.nav'], href: '/home' },
        { icon: '📁', label: t['h2.navCompliance'], href: '/compliance', active: true },
      ]}
      title={t['h2.complianceTitle']}
      who={ctx.display_name}
      ctx={ctx}
      onSignOut={async () => {
        await supabase.auth.signOut();
        navigate('/teacher/login');
      }}
    >
      <ComplianceList />
    </StaffShell>
  );
}

// J2/J6: the public parts — how Swipe keeps answers anonymous, the security
// summary, the processing description, the accessibility statement. No
// sign-in; nothing school-specific.
export function TrustPage() {
  const { t } = useI18n();
  useDocumentTitle(t['cp.trustTitle']);
  return (
    <div className="statement-page">
      <header className="statement-top">
        <Lockup />
        <LangToggle />
      </header>
      <main className="statement" id="main">
        <p><Link to="/teacher/login">← {t['cp.staffLink']}</Link></p>
        <h1>{t['cp.trustTitle']}</h1>
        <ComplianceList source="public_compliance_documents" />
      </main>
    </div>
  );
}
